<script type="text/babel">
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreScrollOnPageBack from 'dashboard-js/mixins/RestoreScrollOnPageBack'

export default {
    mixins: [ManagesModalState, RestoreScrollOnPageBack],

    props: ['course', 'user'],

    data() {
        return {
          totalScored: 0,
          status: 'Fejlet',
          passed: false,
          last_entry_result: false,
        }
    },

    created() {
      let scored = 0
      if(this.course?.course_user_entry?.course_user_answers){
        scored = this.course?.course_user_entry?.course_user_answers.reduce((total, userAnswer) => {
          return total + (userAnswer.answer?.score || 0)
        }, 0)
      }
      const isPassed = scored >= this.course.required_score
      // this.passed = isPassed
      this.last_entry_result = isPassed
      this.totalScored = scored
      this.status = isPassed  ? 'Bestået' : 'Fejlet';
    },

    methods: {
        navigateToCourses() {
            window.location.pathname = `/school`
        },
    },
}
</script>
